module.exports = __webpack_public_path__ + "img/fish.b2af02a8.png";